import React from 'react';

import defaultContext from './defaultUserContext';

const CurrentUserContext = React.createContext(defaultContext);
CurrentUserContext.displayName = 'CurrentUserContext';
export default CurrentUserContext;
